function loop(theme, res, list, type) {
  const suffixes = { main: '', light: 'Light', dark: 'Dark' };
  const suffixe = suffixes[type];
  const contrasts = { main: 'contrastText', light: 'contrastLightText', dark: 'contrastDarkText' };
  const contrast = contrasts[type];
  list.forEach(key => {
    res[`${key}${suffixe}`] = {
      '& .hexaButtonBackLine': {
        fill: theme.palette[key][type],
      },
      '& .hexaButtonLines': {
        stroke: theme.palette[key][type],
      },
      '&:hover .hexaButtonBackContent': {
        fill: theme.palette[key][type],
      },
      '&:hover .hexaButtonLines': {
        stroke: theme.palette[key][contrast],
      },
    };
    res[`${key}${suffixe}2`] = {
      '& .hexaButtonBackLine': {
        fill: theme.palette[key][contrast],
      },
      '& .hexaButtonLines': {
        stroke: theme.palette[key][contrast],
      },
      '&:hover .hexaButtonBackContent': {
        fill: theme.palette[key][contrast],
      },
      '&:hover .hexaButtonLines': {
        stroke: theme.palette[key][type],
      },
    };
  });
}

export default theme => {
  const mains = ['grey', 'green', 'blue', 'yellow', 'red', 'orange', 'pink', 'purpule'];
  const light = ['green', 'blue'];
  const dark = ['purpule'];

  const res = {
    hexaButton: {
      '& .hexaButtonBack': {
        stroke: 'none',
        fill: 'none',
      },
      '& .hexaButtonBackContent': {
        fill: 'transparent',
        transition: 'fill 0.3s',
      },
      '& .hexaButtonLines': {
        fill: 'none',
        strokeLinecap: 'round',
        transition: 'stroke 0.3s',
      },
    },
  };

  loop(theme, res, mains, 'main');
  loop(theme, res, light, 'light');
  loop(theme, res, dark, 'dark');

  return res;
};
